var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row mb-2" }, [
    _c("div", { staticClass: "col-lg-3" }, [_vm._v(_vm._s(_vm.name) + ":")]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-9" }, [
      _c("strong", [_vm._v(_vm._s(_vm.value))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }